// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"3618":"9211ef17","5169":"2019ecbb","9086":"963f27a7","9460":"4d766e15","9567":"704492d6"}[chunkId] + ".css";
};